import React, { PropsWithChildren, useCallback } from 'react';
import { styled } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';

export type Props = {
  value: unknown,
  filter: unknown,
  score: number | null,
  onClick: (value: unknown | null) => void
} & PropsWithChildren;

const Button = styled('button')(({ active }: { active: boolean }) => ({
  cursor: 'pointer',
  display: 'flex',
  gap: '6px',
  alignItems: 'center',
  fontSize: '14px',
  padding: '6px 14px 6px 14px',
  border: 'none',
  ...(active ? {
    background: '#091E42',
    color: '#FFFFFF',
    borderRadius: '14px',
  } : {
    background: 'transparent',
    color: '#6B778C',
  })
}));

const Score = styled('span')({
  color: '#C1C7D0',
});

const ScorePlace = styled('div')({
  //minWidth: '30px',
  textAlign: 'left',
});

export default ({ value, filter, score, children, onClick }: Props) => {

  const handleClick = useCallback(() => onClick(value), [onClick, value]);

  return <Button
    active={value === filter}
    onClick={handleClick}
  >
    {children}
    <ScorePlace>
      {score !== null ? <Score>{score}</Score> : <Skeleton sx={{ bgcolor: '#C1C7D0' }} variant="circular" width={14} height={14}></Skeleton>}
    </ScorePlace>
  </Button>
};